import { Stack } from 'components';
import { axiosPrivate } from 'modules/networkTools/networkTools';
import { useEffect } from 'react';
import { ClientProfileContentItem } from 'store/clientProfile/clientProfileSlice';

const AudioPlayer = ({ note }: { note: ClientProfileContentItem }) => {
  useEffect(() => {
    const fetchAudio = async () => {
      const audioSource = document.getElementById('audio-source') as HTMLSourceElement;

      const result = await axiosPrivate.get(`ai-scribe/audio/${note.aiScribe?.fileUuid}`, {
        responseType: 'blob'
      });

      const blob = await result.data;

      if (blob && audioSource) {
        audioSource.src = URL.createObjectURL(blob);

        (audioSource.parentElement as HTMLAudioElement)?.load();
      } else {
        console.warn('Can not load');
      }
    };

    fetchAudio();
  }, []);

  if (!note?.aiScribe?.audioUrl) return null;

  return (
    <Stack mb="16px">
      <audio controlsList="nodownload" controls style={{ width: '100%' }}>
        <source id="audio-source" type="audio/mp3" />
      </audio>
    </Stack>
  );
};

export default AudioPlayer;
